module.exports = __webpack_public_path__ + "static/media/edge_zh.3715743b.png";